import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {
  Grid,
  Avatar,
} from '@material-ui/core'
import {
  People,
  CameraAlt,
} from '@material-ui/icons'

import { ROUTES, USER_TYPE } from '../constant'
import { getFullName } from '../helpers'
import Button from './Button'
import Breadcrumb from './Breadcrumbs'
import TableAutomation from './TableAutomation'


class ListUsers extends Component {
  /* LIFECYCLE */

  state = {}

  /* METHODS */

  getTableHead = () => {
    const { withType, withActions } = this.props

    const head = [
      '',
      { label: 'Name', sort: 'lastname' },
      { label: 'Email', sort: 'email' },
      { label: 'Registration date', sort: 'created_at' },
    ]

    if (withType) {
      head.splice(2, 0, { label: 'Type', sort: 'type' })
    }

    if (withActions) {
      head.push('Actions')
    }

    return head
  }

  getTableRow = (user) => {
    const { withType, withActions, isConnected } = this.props

    const row = [
      isConnected ? { display: <Avatar sizes="big" src={user.thumbnail || user.picture} /> } : '',
      getFullName(user),
      user.email,
      user.created_at ? moment(user.created_at).format('DD/MM/YYYY - HH:mm') : 'N/A',
    ]

    if (withType) {
      row.splice(2, 0, { display: user.type === USER_TYPE.MODEL ? <People color="primary" /> : <CameraAlt color="secondary" /> })
    }

    if (withActions) {
      row.push({
        display: (
          <Grid container alignItems="center">
            <Button onClick={e => this.props.onValidate(user, e)} color="primary">Accept</Button>
            <Button onClick={e => this.props.onDecline(user, e)} color="secondary">Decline</Button>
          </Grid>
        )
      })
    }

    return row
  }

  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      items,
      title,
      request,
      withType,
      isLoading,
      onItemClick,
      isConnected,
      ...props
    } = this.props

    return (
      <div>
        <Breadcrumb
          data={[
            { label: 'Home', to: ROUTES.HOME },
            title,
          ]}
        />

        <TableAutomation
          items={items}
          title={title}
          request={request}
          onClick={onItemClick}
          row={this.getTableRow}
          head={this.getTableHead()}
          {...props}
        />
      </div>
    )
  }
}


ListUsers.defaultProps = {
  onDecline: () => {},
  onValidate: () => {},
}


ListUsers.propTypes = {
  title: PropTypes.string,
  withType: PropTypes.bool,
  isLoading: PropTypes.bool,
  onDecline: PropTypes.func,
  onValidate: PropTypes.func,
  withActions: PropTypes.bool,
  onItemClick: PropTypes.func,
  isConnected: PropTypes.bool,
  request: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
}


export default ListUsers
